import * as React from 'react';
import SelectedProgramCardWrapper from './SelectedProgramCard.style';
import type { SelectedProgramCardProps } from './SelectedProgramCard.types';

const SelectedProgramCard = ({
  institutionName,
  logoImage,
  programName,
}: SelectedProgramCardProps) => (
  <SelectedProgramCardWrapper>
    <img
      className='selected-program-card__logo'
      src={logoImage}
      alt={programName}
      loading='lazy'
      width='100%'
      height='100%'
    />
    <div className='selected-program-card__text-container'>
      <span className='selected-program-card__text'>{programName}</span>
      <span className='selected-program-card__text'>{institutionName}</span>
    </div>
  </SelectedProgramCardWrapper>
);

export default SelectedProgramCard;
